import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/home/')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/home'),
});
